module.exports = __webpack_public_path__ + "img/SKMJ_lift10.611fb27e.jpg";